const state = {
  //当前入录对象
  audioMsg: {
    title:'',
    isShowAudio: false,
    row: null,
    fileList: null,
    source: null,
    audioType: null,
    type: null,
    doneData: null,
    relationId: '',//当前关联的id
    id:'',//当前录音的id
  },
  audioIndex: null, // 音视频文件索引
  playStatus: false, // 默认是否播放
  doneData: null, // 当前录制的音频信息
  interviewEvaluateId: '',//251904
  audioListRequest: 1,//这里赋一个随机值，用于评价中重新请求录音列表
  truelandUiAudioMsg: {
    title:'',
    isShowAudio: false,
    row: null,
    fileList: null,
    source: null,
    audioType: null,
    type: null,
    doneData: null,
  },
  logs:[]
}
const mutations = {
  // 音视频播放状态
  setPlayStatus: (state, val) => {
    state.playStatus = val.flag
    state.audioIndex = val.index
  },
  // 音视频索引
  setAudioIndex: (state, val) => {
    state.audioIndex = val
  },
  setAudioMsg: (state, val) => {
    state.audioMsg = val
  },
  setTruelandUiAudioMsg: (state, val) => {
    state.truelandUiAudioMsg = val
  },
  setAudioMsgDoneData: (state, val) => {
    state.doneData = val
  },
  setRelationId: (state, val) => {
    state.audioMsg.relationId = val
  },
  setAudioListRequest: (state, val) => {
    state.audioListRequest = val
  },
  setAudioId: (state, val) => {
    state.audioMsg.id = val
  },
}
const actions = {
  // 设置音视频播放索引
  nextAndPrevious({ commit }, index) {
    console.log(index, 'store')
    commit('setAudioIndex', index)
  },
  setPlayStatus({ commit }, flag) {
    commit('setPlayStatus', flag)
  },
  setAudioMsg({ commit }, val) {
    commit('setAudioMsg', val)
  },
  setAudioMsgDoneData({ commit }, val) {
    commit('setAudioMsgDoneData', val)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}

